import React from 'react';
import PropTypes from 'prop-types';

import {
  Col,
  Grid,
  StatsCard,
  StatsCardHeader,
  StatsCardBody,
  StatsCardItem,
} from '@common/components';

import { convertSecondsToTime } from '@dashboard/util';
import { useTranslation } from 'react-i18next';

export default function ResumeTimeUsedCards({ resume }) {
  const { t } = useTranslation('dashboard\\ResumeCards');

  return (
    resume && (
      <Grid
        align="stretch"
        justify="space-between"
        style={{ marginTop: '20px' }}
      >
        <Col xss={12} xs={12} sm={4} md={4}>
          <StatsCard>
            <StatsCardHeader>{t('timeUsedLabel')}</StatsCardHeader>
            <StatsCardBody>
              <StatsCardItem
                text={t('teachersLabel')}
                data={convertSecondsToTime(
                  resume.total_teachers_usage_time || 0,
                )}
              />
              <StatsCardItem
                text={t('studentsLabel')}
                data={convertSecondsToTime(
                  resume.total_students_usage_time || 0,
                )}
              />
            </StatsCardBody>
          </StatsCard>
        </Col>
      </Grid>
    )
  );
}

ResumeTimeUsedCards.propTypes = {
  resume: PropTypes.object,
};
